export default __webpack_public_path__ + "static/media/chat8.66b61532.png";